import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Context } from '../components/Context';
import { IdealFor } from '../components/IdealFor';
import { Solution } from '../components/Solution';
import { Operations } from '../components/Operations';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { FloatingWhatsApp } from '../components/FloatingWhatsApp';

export const Landing = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Context />
      <IdealFor />
      <Solution />
      <Operations />
      <FinalCTA />
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

export default Landing;
